import { Component, OnInit } from '@angular/core';
import { PreformanceStatusService } from '../service/preformance-status.service'
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-preformance-status',
  templateUrl: './preformance-status.component.html',
  styleUrls: ['./preformance-status.component.css']
})
export class PreformanceStatusComponent implements OnInit {

  arrMonth: any[] = [];
  selectedMonth: any = null;
  selectOptionDDL: null;
  cols: any[];
  resultTable: any[] = null;
  msgs: any[] = [];
  gapReport: any[] = null;
  accountManagers: any[];
  accountManagerSelected: any = null;


  constructor(private dataService: PreformanceStatusService, private router: Router) { }
  ngOnInit() {

    this.dataService.GetMonths().subscribe((result: any) => {
      this.arrMonth = result;
      this.selectedMonth = this.arrMonth[this.arrMonth.length - 1];
    });

    this.dataService.getAccountManagersDDL().subscribe((result: any) => {
      this.accountManagers = result;
      //if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length == 1) {
      //  this.accountManagerSelected = this.accountManagers[0].value;
      //}
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });
    
  }

  getData() {          //////////////////////////////////////////////////////////
      this.cols = [
        { field: 'TotalActiveCustomers', header: 'מספר מעסיקים פעילים' },
        { field: 'TotalNonActiveCustomers', header: 'מעסיקים לא פעילים' },
        { field: 'TotalReportedCustomer', header: 'מעסיקים שדיווחו' },
        { field: 'TotalMaximumEmployees', header: 'מספר עובדים מקסימלי' },
        { field: 'TotalWorkerInReportMonth', header: 'מספר עובדים בחודש דיווח' },
        { field: 'TotalCalculatedCostPotential', header: 'פוטנציאל גביה' },
        { field: 'TotalCostCalculatedResultActual', header: 'גביה בפועל - שוטף' },

        { field: 'PercentageCostPotential', header: 'אחוז גביה מול פוטנציאל' },
        //{ field: 'X', header: 'X' },
        { field: 'PercentageRecieved', header: 'אחוז נקלטו על ידי יצרן' },
        { field: 'PercentageNotRecievedYet', header: 'אחוז טרם נתקבל מענה' },
        { field: 'TotalCostCalculatedResultCompletion', header: 'גביה בגין משלימים' },

      ];

      this.dataService.getData(this.accountManagerSelected, this.selectedMonth).subscribe((result: any) => {
          this.resultTable = result;

        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהצגת הדוח');
        });
  }

  //CreateExcelSpecialData() {
  //  try {
  //    var d = new Date();
  //    let fileName = 'PaymentReportSpecialExport.' + d.getFullYear().toString() + '.csv';
  //    this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
  //    this.dataService.downloadExcelSpecialData(this.selectOptionDDL == null ? "" : this.selectOptionDDL, this.selectedMonth, this.isGapDataView).subscribe((result: any) => {
  //      window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
  //      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //        window.navigator.msSaveOrOpenBlob(result, fileName);
  //      }
        
  //      let url = window.URL.createObjectURL(result)
  //      let link = document.createElement('a');
  //      link.href = url;
  //      link.download = `${fileName}`;
  //      link.click();
  //      setTimeout(() => {
  //        this.showMessage('success', '', 'הקובץ נבנה בהצלחה');
  //      }, 1000);
  //    }, (err: HttpErrorResponse) => {
  //      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
  //    });
  //  } catch (error) {
  //    this.showMessage('error', '', 'תקלה בהורדת הקובץ');
  //  }
  //}

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/preformance-status/preformance-status.component.ts